import { FC, memo } from 'react';
import { App as AntdApp } from 'antd';
import type { AppProps } from 'antd';

const AppComponent: FC<AppProps> = memo((props) => {
    return (
        <AntdApp {...props} />
    );
});

type CompoundedComponent = FC<AppProps> & {
    useApp: typeof AntdApp.useApp
};

const AppShell = AppComponent as CompoundedComponent;
AppShell.useApp = AntdApp.useApp;

export default AppShell;
